var ApplicationsAPI = require('../../common/api/application');
var _ = require('underscore');

module.exports = function FindAProjectController(
	$scope,
	$state,
	$rootScope,
	$location
) {
	var vm = this;
	vm.searching = false;
	vm.numberOfPages = 0;

	vm.query = {
		text: '',
		status: 0,
		sort: 'MostRecentDonationDecreasing',
		simple: true
	};
	vm.advancedQuery = { advanced: true, status: 0 };

	vm.init = function() {
		var previous = $location.search();

		vm.pageSize = previous.pageSize || 6;
		vm.pageNumber = previous.pageNumber || 1;

		if (previous.advanced) {
			vm.advancedSearching = true;
			vm.advancedQuery = previous;
			vm.updateQuery(vm.advancedQuery);
			var next = $location.search();
			if (_.isEqual(next, previous)) vm.advancedSearch();
			return;
		}

		vm.advancedSearching = false;
		vm.query = previous.simple ? previous : vm.query;
		vm.updateQuery(vm.query);
		var next = $location.search();
		if (_.isEqual(next, previous)) vm.search();
		return;
	};

	$rootScope.$on('$locationChangeSuccess', function(
		e,
		toState,
		toParams,
		fromState,
		fromParams
	) {
		var previous = $location.search();

		vm.pageSize = previous.pageSize || 6;
		vm.pageNumber = previous.pageNumber || 1;

		if (previous.advanced) {
			vm.advancedSearching = true;
			vm.advancedQuery = previous;
			vm.advancedSearch();
			return;
		}

		vm.advancedSearching = false;
		vm.query = previous.simple ? previous : vm.query;
		vm.search();
	});

	vm.searchChanged = function() {
		vm.pageNumber = 1;
		vm.updateQuery(vm.query);
	};

	vm.toggleAdvancedSearch = function() {
		vm.advancedSearching = !vm.advancedSearching;
		vm.applications = [];
		if (vm.advancedSearching) {
			vm.advancedSearchChanged();
			return;
		}
		vm.searchChanged();
	};

	function searchCallback(result) {
		vm.applications = result.results;
		vm.totalApplications = result.totalResults;

		if (vm.applications && vm.totalApplications) {
			vm.numberOfPages = Math.ceil(vm.totalApplications / vm.pageSize);

			vm.applications.forEach(function(app) {
				app.percentage = 0;
				if (
					!app.grandTotalRaised &&
					!app.totalRequested &&
					!app.totalExternallyRaised
				) {
					return;
				}

				app.percentage = Math.floor(
					app.grandTotalRaised /
						(app.totalRequested + app.totalExternallyRaised) *
						100
				);
				if (app.percentage > 100) {
					app.percentage = 100;
				}
			});
		}
	}

	vm.updateQuery = function(query) {
		var query = angular.copy(query);
		query.pageNumber = vm.pageNumber;
		query.pageSize = vm.pageSize;
		$location.search(query);
	};

	vm.search = function() {
		vm.applications = [];
		vm.searching = true;
		var query = angular.copy(vm.query);
		ApplicationsAPI.Search(
			query.text,
			query.status,
			query.radius,
			null,
			query.area,
			query.sort,
			query.pageSize,
			query.pageNumber
		)
			.then(searchCallback)
			.finally(function() {
				vm.searching = false;
			});
	};

	vm.advancedSearch = function() {
		vm.searching = true;
		var query = angular.copy(vm.advancedQuery);

		ApplicationsAPI.AdvancedSearch(
			query,
			'PublicAdvancedSearchApplicationView'
		)
			.then(searchCallback)
			.catch(function(resp) {
				vm.error = resp.body.message;
			})
			.finally(function() {
				vm.searching = false;
			});
	};

	vm.advancedSearchChanged = function() {
		vm.pageNumber = 1;
		vm.updateQuery(vm.advancedQuery);
	};

	vm.pageChange = function(next, prev) {
		vm.pageNumber = next;
		if (vm.advancedSearching) {
			vm.updateQuery(vm.advancedQuery);
			return;
		}
		vm.updateQuery(vm.query);
	};

	vm.init();
};
